import fetchCategoryPosts from "common/fetch/fetchCategoryPosts";
import fetchSeo from "common/fetch/fetchSeo";
import getClientLocale from "common/fetch/gqlQueryByFetch";

import Layout from "components/common/Layout";
import ArticlesTemplate from "components/templates/hk/articles";

import dataStatic from "./data.json";
// Import ArticlesTemplate from "components/templates/offshore/articles";

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="hk" page={data?.page}>
        <ArticlesTemplate
          data={dataStatic}
          posts={data?.posts}
          categories={data?.children?.children}
        />
        {/* <ArticlesTemplate data={dataStatic} posts={data?.posts} /> */}
      </Layout>
    </div>
  );
}

export const getStaticProps = async () => {
  const locale = "hk";
  const uri = "/articles";
  const page = await fetchSeo({
    uri,
    locale,
  });

  const children = await getClientLocale(locale).query({
    variables: {
      uri,
    },
    query: `
      query theQuery($uri: ID!) {
        category(id: $uri, idType: URI) {
          children {
            nodes {
              name
              uri
            }
          }
        }
      }
    `,
  });

  const posts = await fetchCategoryPosts({
    name: "articles",
    locale,
    size: "LARGE",
    fetchAll: true,
  });

  return {
    props: {
      data: {
        page: page || {},
        posts: posts || [],
        children: children?.data?.category || [],
      },
      revalidate: 1,
    },
  };
};
